import React from 'react';

interface IconProps {
  size?: number;
  bgColor?: string;
  iconColor?: string;
}

export const FacebookIcon: React.FC<IconProps> = ({
  size = 24,
  bgColor = '#fff', // Facebook blue
  iconColor = 'black'
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background Circle */}
      <circle cx="12" cy="12" r="12" fill={bgColor} />

      {/* Facebook "f" */}
      <path
        d="M15.12 8.08h-1.44c-.26 0-.68.13-.68.68v1.24h2.12l-.3 2.14h-1.82V18h-2.24v-5.86H9.28V10h1.48V8.56c0-1.32.64-3.36 3.36-3.36h1.96v2.88Z"
        fill={iconColor}
      />
    </svg>
  );
};
